var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPaymentMethod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7H14",
    stroke: "currentColor",
    strokeWidth: 1.14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9H6",
    stroke: "currentColor",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.5C3 11.0523 3.44772 11.5 4 11.5H8.58691C8.53153 11.6565 8.5 11.8245 8.5 12C8.5 12.1755 8.53153 12.3435 8.58691 12.5H4L3.7959 12.4893C2.78722 12.387 2 11.5357 2 10.5V5.5L2.01074 5.2959C2.1062 4.35435 2.85435 3.6062 3.7959 3.51074L4 3.5H12C13.1046 3.5 14 4.39543 14 5.5V10.5C14 10.6208 13.9863 10.7386 13.9658 10.8535C13.7048 10.6334 13.3682 10.5 13 10.5V5.5C13 4.94772 12.5523 4.5 12 4.5H4C3.44771 4.5 3 4.94772 3 5.5V10.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H13M11.5 10.5V13.5",
    stroke: "currentColor",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPaymentMethod);
export default __webpack_public_path__ + "static/media/add-payment-method.fe396b72f20f9bde32c54803e30326f9.svg";
export { ForwardRef as ReactComponent };